import React, { useState } from "react";
import { supabaseAuth } from "../supabaseClient";

export default function AdminLoginPage({
  onLogin,
  onCreateAccount,
  onBackToHome,
}: {
  onLogin: (user: any) => void;
  onCreateAccount: () => void;
  onBackToHome?: () => void;
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { data, error } = await supabaseAuth.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
  };

  const handleOAuth = async (provider: "google" | "azure") => {
  setError("");
  const { error } = await supabaseAuth.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: `${window.location.origin}/admin-dashboard`
    }
  });
  if (error) setError(error.message);
 };


  return (
    <div className="login-container">
      {onBackToHome && (
        <button className="back-to-home-btn" type="button" onClick={onBackToHome}>
          ← Back to Home
        </button>
      )}
      <div className="login-left">
        <img src="/logo.png" alt="CaseKaizen Logo" className="logo-img" />
        <h1>Welcome to CaseKaizen</h1>
        <p>
          Your AI-powered digital assistant, built to transform the way legal professionals work.
        </p>
        <ul>
          <li>✅ Smarter document management, always organized</li>
          <li>✅ Automated compliance & quality assurance</li>
          <li>✅ Intelligent, time-saving form filling</li>
          <li>✅ Streamlined workflows that let you focus on what matters most</li>
        </ul>
      </div>
      <div className="login-right">
        <h2>Sign In</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <div style={{ color: "red", marginBottom: 8 }}>{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="oauth-divider">or continue with</div>

        <button
          type="button"
          className="oauth-btn google"
          onClick={() => handleOAuth("google")}
        >
          Continue with Google
        </button>
        <button
          type="button"
          className="oauth-btn microsoft"
          onClick={() => handleOAuth("azure")}
        >
          Continue with Microsoft
        </button>

        <div className="signup-link">
          Don&apos;t have an account?{" "}
          <a
            href="#"
            onClick={onCreateAccount}
          >
            Create account
          </a>
        </div>
      </div>
    </div>
  );
}
